import React, { ReactElement, useEffect } from 'react';
import { LoaderButton } from 'idsk-react-components';
import '../legislativnyMaterialHistoria.scss';
import { SprievodnyDokumentStatusEnum } from 'evidencna-aplikacia-frontend-ts-axios';
import iconDownload from '../../../../../assets/images/icon-download-blue.svg';
import Uuid from '../../../../model/Uuid';
import useSprievodnyDokumentExists from '../hooks/useSprievodnyDokumentExists';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import {
  downloadSprievodnyDokumentByTyp,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentDownloadClient';
import downloadFile from '../../../../function/downloadFile';
import fileDownloadErrorStatus from '../../../../constants/FileDownloadErrorConstant';

interface Props {
  legMaterialUuid: Uuid;
  stadiumUuid: Uuid;
  type: string;
}

const VlastnyMaterialButton = ({
  legMaterialUuid,
  stadiumUuid,
  type,
}: Props): ReactElement => {
  const {
    sprievodnyDokumentExistsStatus,
  } = useSprievodnyDokumentExists(
    legMaterialUuid,
    stadiumUuid,
    isPredbeznaInformacia() ? 'PredbeznaInformacia' : 'VlastnyMaterial',
  );
  const {
    wrapClient: downloadSprievodnyDokumentClient,
    status: downloadSprievodnyDokumentStatus,
  } = useClient(downloadSprievodnyDokumentByTyp);
  const { handleStatus } = useClientStatusContext();

  useEffect(() => {
    if (downloadSprievodnyDokumentStatus.responseCode === 404) {
      handleStatus(fileDownloadErrorStatus);
    }
  }, [downloadSprievodnyDokumentStatus, handleStatus]);

  const download = async (): Promise<void> => {
    const { data } = await downloadSprievodnyDokumentClient(
      legMaterialUuid,
      isPredbeznaInformacia() ? 'PredbeznaInformacia' : 'VlastnyMaterial',
      stadiumUuid,
    );

    if (data.blob) {
      downloadFile(data.fileName, data.blob);
    }
  };

  return (
    <LoaderButton
      className="idsk-stepper__link"
      size="small"
      buttonStyle="link"
      customIconBefore={iconDownload}
      loading={downloadSprievodnyDokumentStatus.loading}
      disabled={!sprievodnyDokumentExistsStatus
        || SprievodnyDokumentStatusEnum.DocumentNotFound === sprievodnyDokumentExistsStatus.status}
      onClick={download}
      disableOutsideClickWhileLoading
      aria-label={`Stiahnuť ${isPredbeznaInformacia() ? 'predbežnú informáciu' : 'vlastný materiál'}`}
    >{isPredbeznaInformacia() ? 'Predbežná informácia' : 'Vlastný materiál'}
    </LoaderButton>
  );

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }
};

export default VlastnyMaterialButton;
